module.exports = [{
        path: '/',
        name: 'index',
        component: resolve => require(['@/components/index.vue'], resolve),
        meta: {
            title: "冶金炉料、耐火材料、装备及数字化、耐火原料、唐山冶金炉料大会_第四届中国国际冶金炉料交易博览会在唐山举行",
            content: {
                keywords: "冶金炉料、耐火材料、装备、数字化、耐火原料",
                description: "为了促进钢铁企业、冶金炉料、耐火材料、装备制造、节能环保、企业数字化等企业间的商务、应用交流，提高钢铁产业供应链的采购、销售、物流、生产运行效率，全面推进钢铁产业链企业“供应链交易线上化、生产装备智能化、内部系统集成化”的全面数字化进程。由中国耐火材料行业协会主办，唐山银耐联电子商务有限公司旗下的“银耐联”、“钢源保”平台承办的“第四届中国国际冶金炉料交易博览会”定于2023年3月28-30日在唐山南湖国际会展中心召开。"
            }
        }
    },
    {
        path: '/enterprise',
        name: 'enterprise',
        component: resolve => require(['@/components/enterprise.vue'], resolve),
        meta: {
            title: "铝矾土、白刚玉、棕刚玉、碳化硅、鳞片石墨、镁砂、镁碳砖、增碳剂 _参展企业",
            content: {
                keywords: "耐火材料、参展企业、增碳剂、白刚玉、耐材制品",
                description: "冶金炉料，耐材制品，耐火原料，装备及数字化企业以及对增碳剂、碳粉、白刚玉等耐材制品等产品的参展企业线上展览，企业展厅和产品介绍。"
            }
        }
    },
    {
        path: '/introduce',
        name: 'exintroduce',
        component: resolve => require(['@/components/introduce.vue'], resolve),
        meta: {
            title: "耐火材料、银耐联、钢源保_大会介绍",
            content: {
                keywords: "钢铁、耐火材料、冶金炉料、供应链、环保",
                description: "促进钢铁企业、冶金炉料、耐火材料、装备制造、节能环保、企业数字化等企业间交流，提高钢铁产业供应链的效率，推进钢铁产业链企业“供应链交易线上化、生产装备智能化、内部系统集成化”的全面数字化进程。"
            }
        }
    },
    {
        path: '/dynamic',
        name: 'dynamic',
        component: resolve => require(['@/components/dynamic.vue'], resolve),
        meta: {
            title: "冶金炉料、耐火材料、智能装备制造、唐山_大会动态",
            content: {
                keywords: "冶金炉料、耐火材料、展会信息、耐材之窗",
                description: "耐材之窗全程对此次会议会进行独家报道，冶金炉料行业、耐火材料企业动态、新鲜展会信息就在大会动态栏目。"
            }
        }
    },
    {
        path: '/specimens',
        name: 'specimens',
        component: resolve => require(['@/components/specimens.vue'], resolve),
        meta: {
            title: "冶金炉料 耐火材料 智能装备制造 _大会集锦",
            content: {
                keywords: "集锦、会议、论坛、冶金炉料、耐火材料、智能装备制造",
                description: "此栏目是第四届中国国际冶金炉料交易博览会的照片及视频回顾，包含照片集锦、会议、论坛等同期活动的精彩瞬间。以及展览现场耐火材料企业。智能装备制造企业的风采。"
            }
        }
    },
    {
        path: '/floorplan',
        name: 'floorplan',
        component: resolve => require(['@/components/floorplan.vue'], resolve),
        meta: {
            title: "冶金炉料、耐火材料_展位图",
            content: {
                keywords: "冶金炉料、耐火材料 、展位图、洽谈桌、特装",
                description: "第四届中国国际冶金炉料交易博览会参会参展企业可以从展位图查看，展位分为特装、标展和洽谈桌，展位现场设有展架摆放区域。"
            }
        }
    },
    {
        path: '/mediaFocus',
        name: 'mediaFocus',
        component: resolve => require(['@/components/mediaFocus.vue'], resolve),
        meta: {
            title: "冶金炉料、耐火材料、河北唐山_媒体聚焦",
            content: {
                keywords: "冶金炉料、参会资讯、媒体、报道",
                description: "本栏目会收集关于第四届中国国际冶金炉料交易博览会的参会资讯媒体报道，网站用户可在本页面查找阅读。多家媒体报道将会汇聚于此，欢迎您关注此栏目，了解媒体对大会的报道视角。"
            }
        }
    },
    {
        path: '/forum',
        name: 'forum',
        component: resolve => require(['@/components/forum.vue'], resolve),
        meta: {
            title: "耐火材料、发布会、耐火原料_同期活动",
            content: {
                keywords: "冶金炉料、交易博览会、发布会、耐火材料",
                description: "本栏目主要介绍关于第四届中国国际冶金炉料交易博览会开幕式、关于耐火材料的新产品、新技术、新模式发布会、发展论坛等同期举办的活动"
            }
        }
    },
    {
        path: '/forumdetails',
        name: 'forumdetails',
        component: resolve => require(['@/components/forumdetails.vue'], resolve),
        meta: {
            title: "同期活动详情"
        }
    },
    {
        path: '/dynamicdetails',
        name: 'dynamicdetails',
        component: resolve => require(['@/components/dynamicdetails.vue'], resolve),
        meta: {
            title: "铝矾土 刚玉 耐火 唐山 第四届中国国际冶金炉料交易博览会大会动态详情"
        }
    },
    {
        path: '/information',
        name: 'information',
        component: resolve => require(['@/components/information.vue'], resolve),
        meta: {
            title: "冶金炉料、耐火材料、智能装备制造、河北唐山_参展手册",
            content: {
                keywords: "参展手册、冶金炉料、耐火材料、智能装备",
                description: "欢迎各位耐火原料、耐材制品、辅料、以及智能装备企业客商，希望您能拥有愉快的参展体验，栏目可下载参展手册。"
            }
        }
    },
    {
        path: '/associatedMedia',
        name: 'associatedMedia',
        component: resolve => require(['@/components/associatedMedia.vue'], resolve),
        meta: {
            title: "合作媒体"
        }
    },
    {
        path: '/csshi',
        name: 'ceshi',
        component: resolve => require(['@/components/floorplan.vue'], resolve),
        meta: {
            title: "测试"
        }
    },
    {
        path: '/contactus',
        name: 'contactus',
        component: resolve => require(['@/components/contactus.vue'], resolve),
        meta: {
            title: "联系我们"
        }
    },
    {
        path: '*',
        name: '404',
        meta: {
            title: "404"
        },
        component: resolve => require(['@/components/load404.vue'], resolve)
    }
]